module.exports = __webpack_public_path__ + "img/austria-liver-cancer-female.479b4766.png";